import * as React from "react";

const RoundCloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3091_3389)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0007 4.49992C7.85852 4.49992 4.50065 7.85778 4.50065 11.9999C4.50065 16.1421 7.85852 19.4999 12.0007 19.4999C16.1428 19.4999 19.5007 16.1421 19.5007 11.9999C19.5007 7.85778 16.1428 4.49992 12.0007 4.49992ZM2.83398 11.9999C2.83398 6.93731 6.93804 2.83325 12.0007 2.83325C17.0633 2.83325 21.1673 6.93731 21.1673 11.9999C21.1673 17.0625 17.0633 21.1666 12.0007 21.1666C6.93804 21.1666 2.83398 17.0625 2.83398 11.9999Z"
        fill="#989898"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0899 8.91066C15.4153 9.2361 15.4153 9.76374 15.0899 10.0892L10.0899 15.0892C9.76447 15.4146 9.23683 15.4146 8.9114 15.0892C8.58596 14.7637 8.58596 14.2361 8.9114 13.9107L13.9114 8.91066C14.2368 8.58523 14.7645 8.58523 15.0899 8.91066Z"
        fill="#989898"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.9114 8.91066C9.23683 8.58523 9.76447 8.58523 10.0899 8.91066L15.0899 13.9107C15.4153 14.2361 15.4153 14.7637 15.0899 15.0892C14.7645 15.4146 14.2368 15.4146 13.9114 15.0892L8.9114 10.0892C8.58596 9.76374 8.58596 9.2361 8.9114 8.91066Z"
        fill="#989898"
      />
    </g>
    <defs>
      <clipPath id="clip0_3091_3389">
        <rect width="20" height="20" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);

export default RoundCloseIcon;
